export const UPDATE_APP_VERSION = "UPDATE_APP_VERSION";
